var _path;

import * as React from "react";

function SvgArrowUp(props) {
  return /*#__PURE__*/React.createElement("svg", props, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.498 22.394L4.912 20.81a1.707 1.707 0 010-2.421L18.79 4.504a1.707 1.707 0 012.42 0L35.089 18.38a1.707 1.707 0 010 2.42l-1.586 1.586a1.716 1.716 0 01-2.45-.028l-8.192-8.6v20.527A1.71 1.71 0 0121.146 36h-2.285a1.71 1.71 0 01-1.714-1.714V13.76l-8.2 8.606c-.663.7-1.77.714-2.449.028z"
  })));
}

export default SvgArrowUp;